import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-38f68334"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "center" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "command" }
const _hoisted_4 = { class: "cmd-info-title" }
const _hoisted_5 = { class: "cmd-info-text" }
const _hoisted_6 = { class: "cmd-info-title" }
const _hoisted_7 = { class: "cmd-info-text" }
const _hoisted_8 = { class: "cmd-info-title" }
const _hoisted_9 = { class: "cmd-info-text" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "cmd-info-title" }
const _hoisted_12 = ["innerHTML"]

import {computed, onMounted, reactive} from "vue";
import {useStore} from "vuex";
import {Command} from "@/types/Command";
import GetUsage from "@/utils/GetUsage";
import ParsePerms from "@/utils/ParsePerms";


export default /*#__PURE__*/_defineComponent({
  __name: 'CommandsView',
  setup(__props) {

const store = useStore();
const categories = ['general', 'economy', 'games', 'utilities', 'moderation'];
const icons = ['public', 'attach_money', 'phone_iphone', 'build', 'security'];
let commands = computed(() => (store.getters.commands as Array<Command>));
let dialogs = reactive({})

onMounted(async () => {
  if (!commands.value?.length) await store.dispatch('getCommands')
})

return (_ctx: any,_cache: any) => {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("b", null, _toDisplayString(_ctx.$t('Commands.name')), 1)
    ]),
    (!_unref(commands).length)
      ? (_openBlock(), _createBlock(_component_v_progress_circular, {
          key: 0,
          size: "60",
          width: "5",
          indeterminate: ""
        }))
      : _createCommentVNode("", true),
    (_unref(commands).length)
      ? (_openBlock(), _createBlock(_component_v_expansion_panels, {
          key: 1,
          class: "commands item-center",
          variant: "accordion"
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(categories, (category, i) => {
              return _createVNode(_component_v_expansion_panel, { "bg-color": "block" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_expansion_panel_title, {
                    class: "category",
                    ripple: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, { class: "category-icon" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(icons[i]), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t(`Commands.categories.${category}`)), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_v_expansion_panel_text, null, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(commands).filter(cmd => cmd.category === category), (command, j) => {
                        return (_openBlock(), _createElementBlock("div", null, [
                          _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", null, _toDisplayString(command.config[_ctx.$i18n.locale].name), 1),
                            _createVNode(_component_v_icon, {
                              class: "info-icon",
                              onClick: ($event: any) => (_unref(dialogs)[command.config.en.name] = !_unref(dialogs)[command.config.en.name])
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" info ")
                              ]),
                              _: 2
                            }, 1032, ["onClick"]),
                            _createVNode(_component_v_dialog, {
                              modelValue: _unref(dialogs)[command.config.en.name],
                              "onUpdate:modelValue": ($event: any) => ((_unref(dialogs)[command.config.en.name]) = $event),
                              width: "500",
                              scrollable: ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_card, { color: "modal" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_card_title, { class: "cmd-name" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(command.config[_ctx.$i18n.locale].name.toUpperCase()) + " ", 1),
                                        (command.boostRequired)
                                          ? (_openBlock(), _createBlock(_component_v_btn, {
                                              key: 0,
                                              icon: "",
                                              variant: "text"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_tooltip, {
                                                  "content-class": "tooltip",
                                                  activator: "parent",
                                                  location: "top"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(_ctx.$t('Commands.boostRequired')), 1)
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_v_icon, {
                                                  size: "30",
                                                  color: "#7777ff"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode("favorite")
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_v_card_text, { class: "cmd-info" }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('Commands.description')), 1),
                                        _createElementVNode("div", _hoisted_5, _toDisplayString(command.config[_ctx.$i18n.locale].description), 1),
                                        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('Commands.usage')), 1),
                                        _createElementVNode("div", _hoisted_7, [
                                          _createElementVNode("code", null, _toDisplayString(_unref(GetUsage)(command)), 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('Commands.aliases')), 1),
                                        _createElementVNode("div", _hoisted_9, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(command.config[_ctx.$i18n.locale].aliases, (a) => {
                                            return (_openBlock(), _createBlock(_component_v_chip, {
                                              class: "alias",
                                              variant: "elevated",
                                              color: "secondary"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(a), 1)
                                              ]),
                                              _: 2
                                            }, 1024))
                                          }), 256))
                                        ]),
                                        (command.defaultMemberPermissions?.length)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                              _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('Commands.permissions')), 1),
                                              _createElementVNode("div", {
                                                class: "cmd-info-text",
                                                innerHTML: _unref(ParsePerms)(command)
                                              }, null, 8, _hoisted_12)
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_v_divider, { class: "blue-grey darken-3" }),
                                    _createVNode(_component_v_card_actions, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_spacer),
                                        _createVNode(_component_v_btn, {
                                          text: "",
                                          onClick: ($event: any) => (_unref(dialogs)[command.config.en.name] = false)
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t('Commands.close')), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"])
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1032, ["modelValue", "onUpdate:modelValue"])
                          ]),
                          (j < _unref(commands).filter(c => c.category === category).length-1)
                            ? (_openBlock(), _createBlock(_component_v_divider, { key: 0 }))
                            : _createCommentVNode("", true)
                        ]))
                      }), 256))
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024)
            }), 64))
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})